import headerComponent from './header.component';

const headerModule = angular.module('appHeader', [
])
  .component('appHeader', headerComponent)
  .name;

export default headerModule;
